import { useEffect } from 'react';
import type { DependencyList } from 'react';
import { logger } from '@dist-marketplace-frontend/services';

// Credit to Louis Li: https://louisrli.github.io/blog/2020/06/04/react-dynamic-script-hook/#.YJzjRmZKjUI

function useScript(
  scriptUrl: string,
  scriptId: string,
  deps: DependencyList,
  callback?: () => void,
  appendToBody: boolean = false,
) {
  useEffect(() => {
    try {
      const scriptOnPage = document.getElementById(scriptId);

      if (deps.some((dep) => dep) && !scriptOnPage) {
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.id = scriptId;
        appendToBody
          ? document.body.appendChild(script)
          : document.getElementsByTagName('head')[0].appendChild(script);

        script.onload = () => {
          callback && callback();
        };
      }

      if (scriptOnPage && callback) {
        callback();
      }

      return () => {
        if (scriptOnPage && callback) {
          scriptOnPage.remove();
        }
      };
    } catch (e) {
      const error =
        e instanceof Error
          ? e
          : new Error(`Error loading script ${scriptUrl} `);

      logger.error({
        error,
        message: `Error loading script ${scriptUrl} `,
        customData: {
          scriptUrl,
          scriptId,
          deps,
        },
      });
    }
    // Thanks linter, but this is one time where we're doing the right thing.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export { useScript };
